/**
 * ============================================================================
 * DATA EXPORT COMPONENT - GDPR COMPLIANCE
 * ============================================================================
 * 
 * Component for exporting user data (GDPR Article 20)
 */

/**
 * ============================================================================
 * DATA EXPORT COMPONENT - 100% Ready (GDPR Compliance)
 * ============================================================================
 * 
 * Component for exporting user data (GDPR Article 20)
 */

import { useState } from 'react';
import { exportUserData } from '../../services/users';
import { useToast } from '../../providers';
import { useI18n } from '../../providers';
import Spinner from '../common/Spinner';

const DataExport = () => {
  const [loading, setLoading] = useState(false);
  const { showSuccess, showError } = useToast();
  const { language } = useI18n();

  const handleExport = async () => {
    setLoading(true);

    try {
      await exportUserData();
      showSuccess(
        language === 'fr'
          ? 'Vos données ont été exportées et téléchargées avec succès.'
          : 'Your data has been exported and downloaded successfully.'
      );
    } catch (error) {
      showError(
        error.message ||
          (language === 'fr'
            ? 'Échec de l\'exportation des données. Veuillez réessayer.'
            : 'Failed to export data. Please try again.')
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="dashboard-wt-card-header flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center text-2xl flex-shrink-0">
          📥
        </div>
        <div>
          <h3 className="dashboard-wt-card-title">
            {language === 'fr' ? 'Exporter vos données' : 'Export Your Data'}
          </h3>
          <p className="dashboard-wt-card-desc">
            {language === 'fr'
              ? 'Téléchargez vos données en JSON (profil, transactions, paiements, litiges).'
              : 'Download your data as JSON (profile, transactions, payments, disputes).'}
          </p>
        </div>
      </div>

      <div className="dashboard-wt-card-content">
        <div className="p-3 rounded-lg bg-[rgba(34,197,94,0.08)] border border-[rgba(34,197,94,0.25)] mb-4">
          <div className="flex items-start gap-3">
            <span className="text-lg">ℹ️</span>
            <div>
              <p className="text-sm font-semibold text-white mb-0.5">
                {language === 'fr' ? 'Conformité RGPD (art. 20)' : 'GDPR (Article 20)'}
              </p>
              <p className="text-xs text-[var(--wt-muted)]">
                {language === 'fr'
                  ? 'Droit à la portabilité des données dans un format structuré.'
                  : 'Right to data portability in a structured format.'}
              </p>
            </div>
          </div>
        </div>

        <button
          type="button"
          onClick={handleExport}
          disabled={loading}
          className="dashboard-wt-btn-primary w-full"
        >
          {loading ? (
            <>
              <Spinner size="sm" className="mr-2" />
              {language === 'fr' ? 'Exportation…' : 'Exporting…'}
            </>
          ) : (
            <>📥 {language === 'fr' ? 'Exporter mes données' : 'Export My Data'}</>
          )}
        </button>
      </div>
    </div>
  );
};

export default DataExport;
